module.exports = __webpack_public_path__ + "img/avatar.49233f6c.jpg";